const uploadFileToS3 = (file, uploadUrl) =>
  new Promise((resolve, reject) => {
    const xhr = new XMLHttpRequest()
    xhr.open('PUT', uploadUrl)
    xhr.setRequestHeader('Content-Type', file.type || 'application/octet-stream')
    xhr.onload = () => {
      if (xhr.status >= 200 && xhr.status < 300) {
        resolve(xhr)
      } else {
        reject(new Error(`S3 upload failed: HTTP ${xhr.status}`))
      }
    }
    xhr.onerror = () => reject(new Error(`S3 upload failed for ${file.name}`))
    xhr.send(file)
  })

const UPLOAD_CONCURRENCY = 3

export const uploadFilesToS3 = async (files, uploadFiles) => {
  const results = []

  for (let i = 0; i < files.length; i += UPLOAD_CONCURRENCY) {
    const chunk = files.slice(i, i + UPLOAD_CONCURRENCY)

    // eslint-disable-next-line no-await-in-loop
    const chunkResults = await Promise.all(
      chunk.map(async (file) => {
        const uploadInfo = uploadFiles.find((f) => f.filename === file.name) || uploadFiles[i]
        const s3Response = await uploadFileToS3(file, uploadInfo.upload_url)
        const rawEtag = s3Response.getResponseHeader('etag') || ''

        return {
          filename: file.name,
          object_key: uploadInfo.object_key,
          etag: rawEtag.replace(/"/g, ''),
          size: file.size,
        }
      }),
    )

    results.push(...chunkResults)
  }

  return results
}

export const mapUploadResultsToSendData = (sendData, uploadResults) => {
  sendData.items.forEach((item) => {
    if (item.type === 'files' && Array.isArray(item.content)) {
      item.content.forEach((fileItem) => {
        const uploaded = uploadResults.find((u) => u.filename === fileItem.filename)

        if (uploaded) {
          fileItem.object_key = uploaded.object_key
          fileItem.etag = uploaded.etag
          fileItem.size = uploaded.size
        }
      })
    }
  })
}
